export type CountriesType = {
  text: string;
  country: string;
  code: string;
  flag?: string;
  countryES: string;
  countryPT: string;
  timezones: string[];
  ISOCode: string;
};

export const COUNTRIES: CountriesType[] = [
  {
    text: "+1",
    country: "American Samoa",
    code: "1",
    flag: "🇦🇸",
    countryES: "Samoa Americana",
    countryPT: "Samoa Americana",
    timezones: ["Pacific/Pago_Pago"],
    ISOCode: "AS",
  },
  {
    text: "+1",
    country: "Anguilla",
    code: "1",
    flag: "🇦🇮",
    countryES: "Anguila",
    countryPT: "Anguila",
    timezones: ["America/Puerto_Rico", "America/Anguilla"],
    ISOCode: "AI",
  },
  {
    text: "+1",
    country: "Canada",
    code: "1",
    flag: "🇨🇦",
    countryES: "Canadá",
    countryPT: "Canadá",
    ISOCode: "CA",
    timezones: [
      "America/St_Johns",
      "America/Halifax",
      "America/Glace_Bay",
      "America/Moncton",
      "America/Goose_Bay",
      "America/Toronto",
      "America/Iqaluit",
      "America/Winnipeg",
      "America/Resolute",
      "America/Rankin_Inlet",
      "America/Regina",
      "America/Swift_Current",
      "America/Edmonton",
      "America/Cambridge_Bay",
      "America/Inuvik",
      "America/Dawson_Creek",
      "America/Fort_Nelson",
      "America/Whitehorse",
      "America/Dawson",
      "America/Vancouver",
      "America/Panama",
      "America/Puerto_Rico",
      "America/Phoenix",
      "America/Blanc-Sablon",
      "America/Atikokan",
      "America/Creston",
    ],
  },
  {
    text: "+1",
    country: "Guam",
    code: "1",
    flag: "🇬🇺",
    countryES: "Guam",
    countryPT: "Guam",
    timezones: ["Pacific/Guam"],
    ISOCode: "GU",
  },
  {
    text: "+1",
    country: "Northern Mariana Islands",
    code: "1",
    flag: "🇲🇵",
    countryES: "Islas Marianas del Norte",
    countryPT: "Ilhas Marianas do Norte",
    timezones: ["Pacific/Guam", "Pacific/Saipan"],
    ISOCode: "MP",
  },
  {
    text: "+1",
    country: "United States",
    code: "1",
    flag: "🇺🇸",
    countryES: "Estados Unidos",
    countryPT: "Estados Unidos",
    ISOCode: "US",
    timezones: [
      "America/New_York",
      "America/Detroit",
      "America/Kentucky/Louisville",
      "America/Kentucky/Monticello",
      "America/Indiana/Indianapolis",
      "America/Indiana/Vincennes",
      "America/Indiana/Winamac",
      "America/Indiana/Marengo",
      "America/Indiana/Petersburg",
      "America/Indiana/Vevay",
      "America/Chicago",
      "America/Indiana/Tell_City",
      "America/Indiana/Knox",
      "America/Menominee",
      "America/North_Dakota/Center",
      "America/North_Dakota/New_Salem",
      "America/North_Dakota/Beulah",
      "America/Denver",
      "America/Boise",
      "America/Phoenix",
      "America/Los_Angeles",
      "America/Anchorage",
      "America/Juneau",
      "America/Sitka",
      "America/Metlakatla",
      "America/Yakutat",
      "America/Nome",
      "America/Adak",
      "Pacific/Honolulu",
    ],
  },
  {
    text: "+1",
    country: "Virgin Islands British",
    code: "1",
    flag: "🇻🇬",
    countryES: "Islas Vírgenes Británicas",
    countryPT: "Ilhas Virgens Britânicas",
    timezones: ["America/Puerto_Rico", "America/Tortola"],
    ISOCode: "VG",
  },
  {
    text: "+7",
    country: "Kazakhstan",
    code: "7",
    flag: "�🇿",
    countryES: "Kazajstán",
    countryPT: "Cazaquistão",
    timezones: ["Asia/Almaty", "Asia/Qyzylorda", "Asia/Qostanay", "Asia/Aqtobe", "Asia/Aqtau", "Asia/Atyrau", "Asia/Oral"],
    ISOCode: "KZ",
  },
  {
    text: "+7",
    country: "Russian Federation",
    code: "7",
    flag: "�🇺",
    countryES: "Federación Rusa",
    countryPT: "Federação Russa",
    timezones: [
      "Europe/Kaliningrad",
      "Europe/Moscow",
      "Europe/Simferopol",
      "Europe/Kirov",
      "Europe/Volgograd",
      "Europe/Astrakhan",
      "Europe/Saratov",
      "Europe/Ulyanovsk",
      "Europe/Samara",
      "Asia/Yekaterinburg",
      "Asia/Omsk",
      "Asia/Novosibirsk",
      "Asia/Barnaul",
      "Asia/Tomsk",
      "Asia/Novokuznetsk",
      "Asia/Krasnoyarsk",
      "Asia/Irkutsk",
      "Asia/Chita",
      "Asia/Yakutsk",
      "Asia/Khandyga",
      "Asia/Vladivostok",
      "Asia/Ust-Nera",
      "Asia/Magadan",
      "Asia/Sakhalin",
      "Asia/Srednekolymsk",
      "Asia/Kamchatka",
      "Asia/Anadyr",
    ],
    ISOCode: "RU",
  },
  {
    text: "+20",
    country: "Egypt",
    code: "20",
    flag: "🇪🇬",
    countryES: "Egipto",
    countryPT: "Egito",
    ISOCode: "EG",
    timezones: ["Africa/Cairo"],
  },
  {
    text: "+27",
    country: "South Africa",
    code: "27",
    flag: "🇿🇦",
    countryES: "Sudáfrica",
    countryPT: "África do Sul",
    ISOCode: "ZA",
    timezones: ["Africa/Johannesburg"],
  },
  {
    text: "+30",
    country: "Greece",
    code: "30",
    flag: "🇬🇷",
    countryES: "Grecia",
    countryPT: "Grécia",
    ISOCode: "GR",
    timezones: ["Europe/Athens"],
  },
  {
    text: "+31",
    country: "Netherlands",
    code: "31",
    flag: "🇳🇱",
    countryES: "Países Bajos",
    countryPT: "Holanda",
    ISOCode: "NL",
    timezones: ["Europe/Brussels", "Europe/Amsterdam"],
  },
  {
    text: "+32",
    country: "Belgium",
    code: "32",
    flag: "🇧🇪",
    countryES: "Bélgica",
    countryPT: "Bélgica",
    ISOCode: "BE",
    timezones: ["Europe/Brussels"],
  },
  {
    text: "+33",
    country: "France",
    code: "33",
    flag: "🇫🇷",
    countryES: "Francia",
    countryPT: "França",
    ISOCode: "FR",
    timezones: ["Europe/Paris"],
  },
  {
    text: "+34",
    country: "Spain",
    code: "34",
    flag: "🇪🇸",
    countryES: "España",
    countryPT: "Espanha",
    ISOCode: "ES",
    timezones: ["Europe/Madrid", "Africa/Ceuta", "Atlantic/Canary"],
  },
  {
    text: "+36",
    country: "Hungary",
    code: "36",
    flag: "🇭🇺",
    countryES: "Hungría",
    countryPT: "Hungria",
    ISOCode: "HU",
    timezones: ["Europe/Budapest"],
  },
  {
    text: "+39",
    country: "Vatican City State",
    code: "39",
    flag: "🇻🇦",
    countryES: "Estado de la Ciudad del Vaticano",
    countryPT: "Estado da Cidade do Vaticano",
    timezones: ["Europe/Rome", "Europe/Vatican"],
    ISOCode: "VA",
  },
  {
    text: "+39",
    country: "Italy",
    code: "39",
    flag: "🇮🇹",
    countryES: "Italia",
    countryPT: "Itália",
    ISOCode: "IT",
    timezones: ["Europe/Rome"],
  },
  {
    text: "+40",
    country: "Romania",
    code: "40",
    flag: "🇷🇴",
    countryES: "Rumania",
    countryPT: "Roménia",
    ISOCode: "RO",
    timezones: ["Europe/Bucharest"],
  },
  {
    text: "+41",
    country: "Switzerland",
    code: "41",
    flag: "🇨🇭",
    countryES: "Suiza",
    countryPT: "Suíça",
    ISOCode: "CH",
    timezones: ["Europe/Zurich"],
  },
  {
    text: "+43",
    country: "Austria",
    code: "43",
    flag: "🇦🇹",
    countryES: "Austria",
    countryPT: "Áustria",
    ISOCode: "AT",
    timezones: ["Europe/Vienna"],
  },
  {
    text: "+44",
    country: "United Kingdom",
    code: "44",
    flag: "🇬🇧",
    countryES: "Reino Unido",
    countryPT: "Reino Unido",
    ISOCode: "GB",
    timezones: ["Europe/London"],
  },
  {
    text: "+44",
    country: "Isle of Man",
    code: "44",
    flag: "🇮🇲",
    countryES: "Isla de Man",
    countryPT: "Ilha de Man",
    timezones: ["Europe/London", "Europe/Isle_of_Man"],
    ISOCode: "IM",
  },
  {
    text: "+45",
    country: "Denmark",
    code: "45",
    flag: "🇩🇰",
    countryES: "Dinamarca",
    countryPT: "Dinamarca",
    ISOCode: "DK",
    timezones: ["Europe/Berlin", "Europe/Copenhagen"],
  },
  {
    text: "+46",
    country: "Sweden",
    code: "46",
    flag: "🇸🇪",
    countryES: "Suecia",
    countryPT: "Suécia",
    ISOCode: "SE",
    timezones: ["Europe/Berlin", "Europe/Stockholm"],
  },
  {
    text: "+47",
    country: "Norway",
    code: "47",
    flag: "🇳🇴",
    countryES: "Noruega",
    countryPT: "Noruega",
    ISOCode: "NO",
    timezones: ["Europe/Berlin", "Europe/Oslo"],
  },
  {
    text: "+47",
    country: "Svalbard and Jan Mayen",
    code: "47",
    flag: "🇸🇯",
    countryES: "Svalbard y Jan Mayen",
    countryPT: "Svalbard e Jan Mayen",
    timezones: ["Europe/Berlin", "Arctic/Longyearbyen"],
    ISOCode: "SJ",
  },
  {
    text: "+48",
    country: "Poland",
    code: "48",
    flag: "🇵🇱",
    countryES: "Polonia",
    countryPT: "Polônia",
    ISOCode: "PL",
    timezones: ["Europe/Warsaw"],
  },
  {
    text: "+49",
    country: "Germany",
    code: "49",
    flag: "🇩🇪",
    countryES: "Alemania",
    countryPT: "Alemanha",
    ISOCode: "DE",
    timezones: ["Europe/Zurich", "Europe/Berlin", "Europe/Busingen"],
  },
  {
    text: "+51",
    country: "Peru",
    code: "51",
    flag: "🇵🇪",
    countryES: "Perú",
    countryPT: "Perú",
    ISOCode: "PE",
    timezones: ["America/Lima"],
  },
  {
    text: "+52",
    country: "Mexico",
    code: "52",
    flag: "🇲🇽",
    countryES: "México",
    countryPT: "México",
    ISOCode: "MX",
    timezones: [
      "America/Mexico_City",
      "America/Cancun",
      "America/Merida",
      "America/Monterrey",
      "America/Matamoros",
      "America/Chihuahua",
      "America/Ciudad_Juarez",
      "America/Ojinaga",
      "America/Mazatlan",
      "America/Bahia_Banderas",
      "America/Hermosillo",
      "America/Tijuana",
    ],
  },
  {
    text: "+53",
    country: "Cuba",
    code: "53",
    flag: "🇨🇺",
    countryES: "Cuba",
    countryPT: "Cuba",
    ISOCode: "CU",
    timezones: ["America/Havana"],
  },
  {
    text: "+54",
    country: "Argentina",
    code: "54",
    flag: "🇦🇷",
    countryES: "Argentina",
    countryPT: "Argentina",
    ISOCode: "AR",
    timezones: [
      "America/Argentina/Buenos_Aires",
      "America/Argentina/Cordoba",
      "America/Argentina/Salta",
      "America/Argentina/Jujuy",
      "America/Argentina/Tucuman",
      "America/Argentina/Catamarca",
      "America/Argentina/La_Rioja",
      "America/Argentina/San_Juan",
      "America/Argentina/Mendoza",
      "America/Argentina/San_Luis",
      "America/Argentina/Rio_Gallegos",
      "America/Argentina/Ushuaia",
    ],
  },
  {
    text: "+55",
    country: "Brazil",
    code: "55",
    flag: "🇧🇷",
    countryES: "Brasil",
    countryPT: "Brasil",
    ISOCode: "BR",
    timezones: [
      "America/Noronha",
      "America/Belem",
      "America/Fortaleza",
      "America/Recife",
      "America/Araguaina",
      "America/Maceio",
      "America/Bahia",
      "America/Sao_Paulo",
      "America/Campo_Grande",
      "America/Cuiaba",
      "America/Santarem",
      "America/Porto_Velho",
      "America/Boa_Vista",
      "America/Manaus",
      "America/Eirunepe",
      "America/Rio_Branco",
    ],
  },
  {
    text: "+56",
    country: "Chile",
    code: "56",
    flag: "🇨🇱",
    countryES: "Chile",
    countryPT: "Chile",
    ISOCode: "CL",
    timezones: ["America/Santiago", "America/Punta_Arenas", "Pacific/Easter"],
  },
  {
    text: "+57",
    country: "Colombia",
    code: "57",
    flag: "🇨🇴",
    countryES: "Colombia",
    countryPT: "Colômbia",
    ISOCode: "CO",
    timezones: ["America/Bogota"],
  },
  {
    text: "+58",
    country: "Venezuela",
    code: "58",
    flag: "🇻🇪",
    countryES: "Venezuela",
    countryPT: "Venezuela",
    ISOCode: "VE",
    timezones: ["America/Caracas"],
  },
  {
    text: "+60",
    country: "Malaysia",
    code: "60",
    flag: "🇲🇾",
    countryES: "Malasia",
    countryPT: "Malásia",
    ISOCode: "MY",
    timezones: ["Asia/Kuching", "Asia/Singapore", "Asia/Kuala_Lumpur"],
  },
  {
    text: "+61",
    country: "Australia",
    code: "61",
    flag: "🇦🇺",
    countryES: "Australia",
    countryPT: "Austrália",
    ISOCode: "AU",
    timezones: [
      "Australia/Lord_Howe",
      "Antarctica/Macquarie",
      "Australia/Hobart",
      "Australia/Melbourne",
      "Australia/Sydney",
      "Australia/Broken_Hill",
      "Australia/Brisbane",
      "Australia/Lindeman",
      "Australia/Adelaide",
      "Australia/Darwin",
      "Australia/Perth",
      "Australia/Eucla",
    ],
  },
  {
    text: "+61",
    country: "Cocos (Keeling) Islands",
    code: "61",
    flag: "🇨🇨",
    countryES: "Islas Cocos (Keeling)",
    countryPT: "Ilhas Cocos (Keeling)",
    timezones: ["Asia/Yangon", "Indian/Cocos"],
    ISOCode: "CC",
  },
  {
    text: "+62",
    country: "Indonesia",
    code: "62",
    flag: "🇮🇩",
    countryES: "Indonesia",
    countryPT: "Indonésia",
    ISOCode: "ID",
    timezones: ["Asia/Jakarta", "Asia/Pontianak", "Asia/Makassar", "Asia/Jayapura"],
  },
  {
    text: "+63",
    country: "Philippines",
    code: "63",
    flag: "🇵🇭",
    countryES: "Filipinas",
    countryPT: "Filipinas",
    ISOCode: "PH",
    timezones: ["Asia/Manila"],
  },
  {
    text: "+64",
    country: "New Zealand",
    code: "64",
    flag: "🇳🇿",
    countryES: "Nueva Zelanda",
    countryPT: "Nova Zelândia",
    ISOCode: "NZ",
    timezones: ["Pacific/Auckland", "Pacific/Chatham"],
  },
  {
    text: "+65",
    country: "Singapore",
    code: "65",
    flag: "🇸🇬",
    countryES: "Singapur",
    countryPT: "Singapura",
    ISOCode: "SG",
    timezones: ["Asia/Singapore"],
  },
  {
    text: "+66",
    country: "Thailand",
    code: "66",
    flag: "🇹🇭",
    countryES: "Tailandia",
    countryPT: "Tailândia",
    ISOCode: "TH",
    timezones: ["Asia/Bangkok"],
  },
  {
    text: "+81",
    country: "Japan",
    code: "81",
    flag: "🇯🇵",
    countryES: "Japón",
    countryPT: "Japão",
    ISOCode: "JP",
    timezones: ["Asia/Tokyo"],
  },
  {
    text: "+82",
    country: "Korea Republic",
    code: "82",
    flag: "🇰🇷",
    countryES: "República de Corea",
    countryPT: "Coreia do Sul",
    timezones: ["Asia/Seoul"],
    ISOCode: "KR",
  },
  {
    text: "+84",
    country: "Vietnam",
    code: "84",
    flag: "🇻🇳",
    countryES: "Vietnam",
    countryPT: "Vietnã",
    ISOCode: "VN",
    timezones: ["Asia/Bangkok", "Asia/Ho_Chi_Minh"],
  },
  {
    text: "+86",
    country: "China",
    code: "86",
    flag: "🇨🇳",
    countryES: "China",
    countryPT: "China",
    ISOCode: "CN",
    timezones: ["Asia/Shanghai", "Asia/Urumqi"],
  },
  {
    text: "+90",
    country: "Turkey",
    code: "90",
    flag: "🇹🇷",
    countryES: "Turquía",
    countryPT: "Turquia",
    ISOCode: "TR",
    timezones: ["Europe/Istanbul"],
  },
  {
    text: "+91",
    country: "India",
    code: "91",
    flag: "🇮🇳",
    countryES: "India",
    countryPT: "Índia",
    ISOCode: "IN",
    timezones: ["Asia/Kolkata"],
  },
  {
    text: "+92",
    country: "Pakistan",
    code: "92",
    flag: "🇵🇰",
    countryES: "Pakistán",
    countryPT: "Paquistão",
    ISOCode: "PK",
    timezones: ["Asia/Karachi"],
  },
  {
    text: "+93",
    country: "Afghanistan",
    code: "93",
    flag: "🇦🇫",
    countryES: "Afganistán",
    countryPT: "Afeganistão",
    ISOCode: "AF",
    timezones: ["Asia/Kabul"],
  },
  {
    text: "+94",
    country: "Sri Lanka",
    code: "94",
    flag: "🇱🇰",
    countryES: "Sri Lanka",
    countryPT: "Sri Lanca",
    ISOCode: "LK",
    timezones: ["Asia/Colombo"],
  },
  {
    text: "+95",
    country: "Myanmar",
    code: "95",
    flag: "🇲🇲",
    countryES: "Birmania",
    countryPT: "Mianmar",
    ISOCode: "MM",
    timezones: ["Asia/Yangon"],
  },
  {
    text: "+98",
    country: "Iran",
    code: "98",
    flag: "🇮🇷",
    countryES: "Irán",
    countryPT: "Irã",
    ISOCode: "IR",
    timezones: ["Asia/Tehran"],
  },
  {
    text: "+211",
    country: "South Sudan",
    code: "211",
    flag: "🇸🇸",
    countryES: "Sudán del Sur",
    countryPT: "Sudão do Sul",
    timezones: ["Africa/Juba"],
    ISOCode: "SS",
  },
  {
    text: "+212",
    country: "Western Sahara",
    code: "212",
    flag: "🇪🇭",
    countryES: "Sáhara Occidental",
    countryPT: "Saara Ocidental",
    ISOCode: "EH",
    timezones: ["Africa/El_Aaiun"],
  },
  {
    text: "+213",
    country: "Algeria",
    code: "213",
    flag: "🇩🇿",
    countryES: "Argelia",
    countryPT: "Argélia",
    ISOCode: "DZ",
    timezones: ["Africa/Algiers"],
  },
  {
    text: "+216",
    country: "Tunisia",
    code: "216",
    flag: "🇹🇳",
    countryES: "Túnez",
    countryPT: "Tunísia",
    ISOCode: "TN",
    timezones: ["Africa/Tunis"],
  },
  {
    text: "+218",
    country: "Libya",
    code: "218",
    flag: "🇱🇾",
    countryES: "Libia",
    countryPT: "Líbia",
    ISOCode: "LY",
    timezones: ["Africa/Tripoli"],
  },
  {
    text: "+220",
    country: "Gambia",
    code: "220",
    flag: "🇬🇲",
    countryES: "Gambia",
    countryPT: "Gâmbia",
    ISOCode: "GM",
    timezones: ["Africa/Abidjan", "Africa/Banjul"],
  },
  {
    text: "+221",
    country: "Senegal",
    code: "221",
    flag: "🇸🇳",
    countryES: "Senegal",
    countryPT: "Senegal",
    ISOCode: "SN",
    timezones: ["Africa/Abidjan", "Africa/Dakar"],
  },
  {
    text: "+222",
    country: "Mauritania",
    code: "222",
    flag: "🇲🇷",
    countryES: "Mauritania",
    countryPT: "Mauritânia",
    ISOCode: "MR",
    timezones: ["Africa/Abidjan", "Africa/Nouakchott"],
  },
  {
    text: "+223",
    country: "Mali",
    code: "223",
    flag: "🇲🇱",
    countryES: "Malí",
    countryPT: "Mali",
    ISOCode: "ML",
    timezones: ["Africa/Abidjan", "Africa/Bamako"],
  },
  {
    text: "+224",
    country: "Guinea",
    code: "224",
    flag: "🇬🇳",
    countryES: "Guinea",
    countryPT: "Guiné",
    ISOCode: "GN",
    timezones: ["Africa/Abidjan", "Africa/Conakry"],
  },
  {
    text: "+225",
    country: "Cote dIvoire",
    code: "225",
    flag: "🇨🇮",
    countryES: "Costa de Marfil",
    countryPT: "Costa do Marfim",
    timezones: ["Africa/Abidjan"],
    ISOCode: "CI",
  },
  {
    text: "+226",
    country: "Burkina Faso",
    code: "226",
    flag: "🇧🇫",
    countryES: "Burkina Faso",
    countryPT: "Burquina Faso",
    ISOCode: "BF",
    timezones: ["Africa/Abidjan", "Africa/Ouagadougou"],
  },
  {
    text: "+227",
    country: "Niger",
    code: "227",
    flag: "🇳🇪",
    countryES: "Níger",
    countryPT: "Níger",
    ISOCode: "NE",
    timezones: ["Africa/Lagos", "Africa/Niamey"],
  },
  {
    text: "+228",
    country: "Togo",
    code: "228",
    flag: "🇹🇬",
    countryES: "Togo",
    countryPT: "Togo",
    ISOCode: "TG",
    timezones: ["Africa/Abidjan", "Africa/Lome"],
  },
  {
    text: "+229",
    country: "Benin",
    code: "229",
    flag: "🇧🇯",
    countryES: "Benín",
    countryPT: "Benim",
    ISOCode: "BJ",
    timezones: ["Africa/Lagos", "Africa/Porto-Novo"],
  },
  {
    text: "+230",
    country: "Mauritius",
    code: "230",
    flag: "🇲🇺",
    countryES: "Mauricio",
    countryPT: "Maurício",
    ISOCode: "MU",
    timezones: ["Indian/Mauritius"],
  },
  {
    text: "+231",
    country: "Liberia",
    code: "231",
    flag: "🇱🇷",
    countryES: "Liberia",
    countryPT: "Libéria",
    ISOCode: "LR",
    timezones: ["Africa/Monrovia"],
  },
  {
    text: "+232",
    country: "Sierra Leone",
    code: "232",
    flag: "🇸🇱",
    countryES: "Sierra Leona",
    countryPT: "Serra Leoa",
    ISOCode: "SL",
    timezones: ["Africa/Abidjan", "Africa/Freetown"],
  },
  {
    text: "+233",
    country: "Ghana",
    code: "233",
    flag: "🇬🇭",
    countryES: "Ghana",
    countryPT: "Gana",
    ISOCode: "GH",
    timezones: ["Africa/Abidjan", "Africa/Accra"],
  },
  {
    text: "+234",
    country: "Nigeria",
    code: "234",
    flag: "🇳🇬",
    countryES: "Nigeria",
    countryPT: "Nigéria",
    ISOCode: "NG",
    timezones: ["Africa/Lagos"],
  },
  {
    text: "+236",
    country: "Central African Republic",
    code: "236",
    flag: "🇨🇫",
    countryES: "República Centroafricana",
    countryPT: "República Centro-Africana",
    ISOCode: "CF",
    timezones: ["Africa/Lagos", "Africa/Bangui"],
  },
  {
    text: "+237",
    country: "Cameroon",
    code: "237",
    flag: "🇨🇲",
    countryES: "Camerún",
    countryPT: "Camarões",
    ISOCode: "CM",
    timezones: ["Africa/Lagos", "Africa/Douala"],
  },
  {
    text: "+238",
    country: "Cape Verde",
    code: "238",
    flag: "🇨🇻",
    countryES: "Cabo Verde",
    countryPT: "Cabo Verde",
    ISOCode: "CV",
    timezones: ["Atlantic/Cape_Verde"],
  },
  {
    text: "+239",
    country: "Sao Tome and Principe",
    code: "239",
    flag: "🇸🇹",
    countryES: "Santo Tomé y Príncipe",
    countryPT: "São Tomé e Príncipe",
    ISOCode: "ST",
    timezones: ["Africa/Sao_Tome"],
  },
  {
    text: "+240",
    country: "Equatorial Guinea",
    code: "240",
    flag: "🇬🇶",
    countryES: "Guinea Ecuatorial",
    countryPT: "Guiné Equatorial",
    ISOCode: "GQ",
    timezones: ["Africa/Lagos", "Africa/Malabo"],
  },
  {
    text: "+241",
    country: "Gabon",
    code: "241",
    flag: "🇬🇦",
    countryES: "Gabón",
    countryPT: "Gabão",
    ISOCode: "GA",
    timezones: ["Africa/Lagos", "Africa/Libreville"],
  },
  {
    text: "+242",
    country: "Congo",
    code: "242",
    flag: "🇨🇬",
    countryES: "Congo",
    countryPT: "Congo",
    timezones: ["Africa/Lagos", "Africa/Brazzaville"],
    ISOCode: "CG",
  },
  {
    text: "+243",
    country: "Zaire",
    code: "243",
    flag: "🇨🇩",
    countryES: "Zaire",
    countryPT: "Zaire",
    timezones: ["Africa/Maputo", "Africa/Lagos", "Africa/Kinshasa", "Africa/Lubumbashi"],
    ISOCode: "CD",
  },
  {
    text: "+244",
    country: "Angola",
    code: "244",
    flag: "🇦🇴",
    countryES: "Angola",
    countryPT: "Angola",
    ISOCode: "AO",
    timezones: ["Africa/Lagos", "Africa/Luanda"],
  },
  {
    text: "+245",
    country: "Guinea-Bissau",
    code: "245",
    flag: "🇬🇼",
    countryES: "Guinea-Bisáu",
    countryPT: "Guiné-Bissau",
    ISOCode: "GW",
    timezones: ["Africa/Bissau"],
  },
  {
    text: "+248",
    country: "Seychelles",
    code: "248",
    flag: "🇸🇨",
    countryES: "Seychelles",
    countryPT: "Seicheles",
    ISOCode: "SC",
    timezones: ["Asia/Dubai", "Indian/Mahe"],
  },
  {
    text: "+249",
    country: "Sudan",
    code: "249",
    flag: "🇸🇩",
    countryES: "Sudán",
    countryPT: "Sudão",
    ISOCode: "SD",
    timezones: ["Africa/Khartoum"],
  },
  {
    text: "+250",
    country: "Rwanda",
    code: "250",
    flag: "🇷🇼",
    countryES: "Ruanda",
    countryPT: "Ruanda",
    ISOCode: "RW",
    timezones: ["Africa/Maputo", "Africa/Kigali"],
  },
  {
    text: "+251",
    country: "Ethiopia",
    code: "251",
    flag: "🇪🇹",
    countryES: "Etiopía",
    countryPT: "Etiópia",
    ISOCode: "ET",
    timezones: ["Africa/Nairobi", "Africa/Addis_Ababa"],
  },
  {
    text: "+252",
    country: "Somalia",
    code: "252",
    flag: "🇸🇴",
    countryES: "Somalia",
    countryPT: "Somália",
    ISOCode: "SO",
    timezones: ["Africa/Nairobi", "Africa/Mogadishu"],
  },
  {
    text: "+253",
    country: "Djibouti",
    code: "253",
    flag: "🇩🇯",
    countryES: "Yibuti",
    countryPT: "Djibuti",
    ISOCode: "DJ",
    timezones: ["Africa/Nairobi", "Africa/Djibouti"],
  },
  {
    text: "+254",
    country: "Kenya",
    code: "254",
    flag: "🇰🇪",
    countryES: "Kenia",
    countryPT: "Quênia",
    ISOCode: "KE",
    timezones: ["Africa/Nairobi"],
  },
  {
    text: "+255",
    country: "Tanzania",
    code: "255",
    flag: "🇹🇿",
    countryES: "Tanzanía",
    countryPT: "Tanzânia",
    ISOCode: "TZ",
    timezones: ["Africa/Nairobi", "Africa/Dar_es_Salaam"],
  },
  {
    text: "+256",
    country: "Uganda",
    code: "256",
    flag: "🇺🇬",
    countryES: "Uganda",
    countryPT: "Uganda",
    ISOCode: "UG",
    timezones: ["Africa/Nairobi", "Africa/Kampala"],
  },
  {
    text: "+257",
    country: "Burundi",
    code: "257",
    flag: "🇧🇮",
    countryES: "Burundi",
    countryPT: "Burundi",
    ISOCode: "BI",
    timezones: ["Africa/Maputo", "Africa/Bujumbura"],
  },
  {
    text: "+258",
    country: "Mozambique",
    code: "258",
    flag: "🇲🇿",
    countryES: "Mozambique",
    countryPT: "Moçambique",
    ISOCode: "MZ",
    timezones: ["Africa/Maputo"],
  },
  {
    text: "+260",
    country: "Zambia",
    code: "260",
    flag: "🇿🇲",
    countryES: "Zambia",
    countryPT: "Zâmbia",
    ISOCode: "ZM",
    timezones: ["Africa/Maputo", "Africa/Lusaka"],
  },
  {
    text: "+261",
    country: "Madagascar",
    code: "261",
    flag: "🇲🇬",
    countryES: "Madagascar",
    countryPT: "Madagáscar",
    ISOCode: "MG",
    timezones: ["Africa/Nairobi", "Indian/Antananarivo"],
  },
  {
    text: "+262",
    country: "Reunion",
    code: "262",
    flag: "🇷🇪",
    countryES: "Reunión",
    countryPT: "Reunião",
    timezones: ["Asia/Dubai", "Indian/Reunion"],
    ISOCode: "RE",
  },
  {
    text: "+263",
    country: "Zimbabwe",
    code: "263",
    flag: "🇿🇼",
    countryES: "Zimbabue",
    countryPT: "Zimbabué",
    ISOCode: "ZW",
    timezones: ["Africa/Maputo", "Africa/Harare"],
  },
  {
    text: "+264",
    country: "Namibia",
    code: "264",
    flag: "🇳🇦",
    countryES: "Namibia",
    countryPT: "Namíbia",
    ISOCode: "NA",
    timezones: ["Africa/Windhoek"],
  },
  {
    text: "+265",
    country: "Malawi",
    code: "265",
    flag: "🇲🇼",
    countryES: "Malaui",
    countryPT: "Maláui",
    ISOCode: "MW",
    timezones: ["Africa/Maputo", "Africa/Blantyre"],
  },
  {
    text: "+266",
    country: "Lesotho",
    code: "266",
    flag: "🇱🇸",
    countryES: "Lesoto",
    countryPT: "Lesoto",
    ISOCode: "LS",
    timezones: ["Africa/Johannesburg", "Africa/Maseru"],
  },
  {
    text: "+267",
    country: "Botswana",
    code: "267",
    flag: "🇧🇼",
    countryES: "Botsuana",
    countryPT: "Botsuana",
    ISOCode: "BW",
    timezones: ["Africa/Maputo", "Africa/Gaborone"],
  },
  {
    text: "+268",
    country: "Swaziland",
    code: "268",
    flag: "🇸🇿",
    countryES: "Suazilandia",
    countryPT: "Suazilândia",
    ISOCode: "SZ",
    timezones: ["Africa/Johannesburg", "Africa/Mbabane"],
  },
  {
    text: "+269",
    country: "Comoros",
    code: "269",
    flag: "🇰🇲",
    countryES: "Comoras",
    countryPT: "Comores",
    ISOCode: "KM",
    timezones: ["Africa/Nairobi", "Indian/Comoro"],
  },
  {
    text: "+290",
    country: "Saint Helena Ascension and Tristan da C",
    code: "290",
    flag: "🇸🇭",
    countryES: "Ascensión de Santa Elena y Tristán da C",
    countryPT: "Ascensão de Santa Helena e Tristão da C",
    timezones: ["Africa/Abidjan", "Atlantic/St_Helena"],
    ISOCode: "SH",
  },
  {
    text: "+291",
    country: "Eritrea",
    code: "291",
    flag: "🇪🇷",
    countryES: "Eritrea",
    countryPT: "Eritreia",
    ISOCode: "ER",
    timezones: ["Africa/Nairobi", "Africa/Asmara"],
  },
  {
    text: "+297",
    country: "Aruba",
    code: "297",
    flag: "🇦🇼",
    countryES: "Cuba",
    countryPT: "Aruba",
    timezones: ["America/Puerto_Rico", "America/Aruba"],
    ISOCode: "AW",
  },
  {
    text: "+298",
    country: "Faroe Islands",
    code: "298",
    flag: "🇫🇴",
    countryES: "Islas Feroe",
    countryPT: "Ilhas Faroé",
    timezones: ["Atlantic/Faroe"],
    ISOCode: "FO",
  },
  {
    text: "+299",
    country: "Greenland",
    code: "299",
    flag: "🇬🇱",
    countryES: "Groenlandia",
    countryPT: "Groenlândia",
    ISOCode: "GL",
    timezones: ["America/Nuuk", "America/Danmarkshavn", "America/Scoresbysund", "America/Thule"],
  },
  {
    text: "+350",
    country: "Gibraltar",
    code: "350",
    flag: "🇬🇮",
    countryES: "Gibraltar",
    countryPT: "Gibraltar",
    timezones: ["Europe/Gibraltar"],
    ISOCode: "GI",
  },
  {
    text: "+351",
    country: "Portugal",
    code: "351",
    flag: "🇵🇹",
    countryES: "Portugal",
    countryPT: "Portugal",
    ISOCode: "PT",
    timezones: ["Europe/Lisbon", "Atlantic/Madeira", "Atlantic/Azores"],
  },
  {
    text: "+352",
    country: "Luxembourg",
    code: "352",
    flag: "🇱🇺",
    countryES: "Luxemburgo",
    countryPT: "Luxemburgo",
    ISOCode: "LU",
    timezones: ["Europe/Brussels", "Europe/Luxembourg"],
  },
  {
    text: "+353",
    country: "Ireland",
    code: "353",
    flag: "🇮🇪",
    countryES: "Irlanda",
    countryPT: "Irlanda",
    ISOCode: "IE",
    timezones: ["Europe/Dublin"],
  },
  {
    text: "+354",
    country: "Iceland",
    code: "354",
    flag: "🇮🇸",
    countryES: "Islandia",
    countryPT: "Islândia",
    ISOCode: "IS",
    timezones: ["Africa/Abidjan", "Atlantic/Reykjavik"],
  },
  {
    text: "+355",
    country: "Albania",
    code: "355",
    flag: "🇦🇱",
    countryES: "Albania",
    countryPT: "Albânia",
    ISOCode: "AL",
    timezones: ["Europe/Tirane"],
  },
  {
    text: "+356",
    country: "Malta",
    code: "356",
    flag: "🇲🇹",
    countryES: "Malta",
    countryPT: "Malta",
    ISOCode: "MT",
    timezones: ["Europe/Malta"],
  },
  {
    text: "+357",
    country: "Cyprus",
    code: "357",
    flag: "🇨🇾",
    countryES: "Chipre",
    countryPT: "Chipre",
    ISOCode: "CY",
    timezones: ["Asia/Nicosia", "Asia/Famagusta"],
  },
  {
    text: "+358",
    country: "Finland",
    code: "358",
    flag: "🇫🇮",
    countryES: "Finlandia",
    countryPT: "Finlândia",
    ISOCode: "FI",
    timezones: ["Europe/Helsinki"],
  },
  {
    text: "+359",
    country: "Bulgaria",
    code: "359",
    flag: "🇧🇬",
    countryES: "Bulgaria",
    countryPT: "Bulgária",
    ISOCode: "BG",
    timezones: ["Europe/Sofia"],
  },
  {
    text: "+370",
    country: "Lithuania",
    code: "370",
    flag: "🇱🇹",
    countryES: "Lituania",
    countryPT: "Lituânia",
    ISOCode: "LT",
    timezones: ["Europe/Vilnius"],
  },
  {
    text: "+371",
    country: "Latvia",
    code: "371",
    flag: "🇱🇻",
    countryES: "Letonia",
    countryPT: "Letônia",
    ISOCode: "LV",
    timezones: ["Europe/Riga"],
  },
  {
    text: "+372",
    country: "Estonia",
    code: "372",
    flag: "🇪🇪",
    countryES: "Estonia",
    countryPT: "Estônia",
    ISOCode: "EE",
    timezones: ["Europe/Tallinn"],
  },
  {
    text: "+373",
    country: "Moldova",
    code: "373",
    flag: "🇲🇩",
    countryES: "Moldavia",
    countryPT: "Moldávia",
    ISOCode: "MD",
    timezones: ["Europe/Chisinau"],
  },
  {
    text: "+374",
    country: "Armenia",
    code: "374",
    flag: "🇦🇲",
    countryES: "Armenia",
    countryPT: "Armênia",
    ISOCode: "AM",
    timezones: ["Asia/Yerevan"],
  },
  {
    text: "+375",
    country: "Belarus",
    code: "375",
    flag: "🇧🇾",
    countryES: "Bielorrusia",
    countryPT: "Bielorrússia",
    ISOCode: "BY",
    timezones: ["Europe/Minsk"],
  },
  {
    text: "+376",
    country: "Andorra",
    code: "376",
    flag: "🇦🇩",
    countryES: "Andorra",
    countryPT: "Andorra",
    timezones: ["Europe/Andorra"],
    ISOCode: "AD",
  },
  {
    text: "+377",
    country: "Monaco",
    code: "377",
    flag: "🇲🇨",
    countryES: "Mónaco",
    countryPT: "Mônaco",
    ISOCode: "MC",
    timezones: ["Europe/Paris", "Europe/Monaco"],
  },
  {
    text: "+378",
    country: "San Marino",
    code: "378",
    flag: "🇸🇲",
    countryES: "San Marino",
    countryPT: "São Marino",
    ISOCode: "SM",
    timezones: ["Europe/Rome", "Europe/San_Marino"],
  },
  {
    text: "+380",
    country: "Ukraine",
    code: "380",
    flag: "🇺🇦",
    countryES: "Ucrania",
    countryPT: "Ucrânia",
    ISOCode: "UA",
    timezones: ["Europe/Simferopol", "Europe/Kyiv"],
  },
  {
    text: "+381",
    country: "Serbia",
    code: "381",
    flag: "🇷🇸",
    countryES: "Serbia",
    countryPT: "Sérvia",
    ISOCode: "RS",
    timezones: ["Europe/Belgrade"],
  },
  {
    text: "+382",
    country: "Montenegro",
    code: "382",
    flag: "🇲🇪",
    countryES: "Montenegro",
    countryPT: "Montenegro",
    ISOCode: "ME",
    timezones: ["Europe/Belgrade", "Europe/Podgorica"],
  },
  {
    text: "+385",
    country: "Croatia",
    code: "385",
    flag: "🇭🇷",
    countryES: "Croacia",
    countryPT: "Croácia",
    ISOCode: "HR",
    timezones: ["Europe/Belgrade", "Europe/Zagreb"],
  },
  {
    text: "+386",
    country: "Slovenia",
    code: "386",
    flag: "🇸🇮",
    countryES: "Eslovenia",
    countryPT: "Eslovênia",
    ISOCode: "SI",
    timezones: ["Europe/Belgrade", "Europe/Ljubljana"],
  },
  {
    text: "+387",
    country: "Bosnia and Herzegovina",
    code: "387",
    flag: "🇧🇦",
    countryES: "Bosnia y Herzegovina",
    countryPT: "Bósnia e Herzegovina",
    ISOCode: "BA",
    timezones: ["Europe/Belgrade", "Europe/Sarajevo"],
  },
  {
    text: "+389",
    country: "Macedonia",
    code: "389",
    flag: "🇲🇰",
    countryES: "Macedonia",
    countryPT: "Macedônia",
    ISOCode: "MK",
    timezones: ["Europe/Belgrade", "Europe/Skopje"],
  },
  {
    text: "+420",
    country: "Czech Republic",
    code: "420",
    flag: "🇨🇿",
    countryES: "República Checa",
    countryPT: "República Checa",
    ISOCode: "CZ",
    timezones: ["Europe/Prague"],
  },
  {
    text: "+421",
    country: "Slovakia",
    code: "421",
    flag: "🇸🇰",
    countryES: "Eslovaquia",
    countryPT: "Eslováquia",
    ISOCode: "SK",
    timezones: ["Europe/Prague", "Europe/Bratislava"],
  },
  {
    text: "+423",
    country: "Liechtenstein",
    code: "423",
    flag: "🇱🇮",
    countryES: "Liechtenstein",
    countryPT: "Liechtenstein",
    ISOCode: "LI",
    timezones: ["Europe/Zurich", "Europe/Vaduz"],
  },
  {
    text: "+500",
    country: "Falkland Islands",
    code: "500",
    flag: "🇫🇰",
    countryES: "Islas Malvinas",
    countryPT: "Ilhas Malvinas",
    timezones: ["Atlantic/Stanley"],
    ISOCode: "FK",
  },
  {
    text: "+501",
    country: "Belize",
    code: "501",
    flag: "🇧🇿",
    countryES: "Belice",
    countryPT: "Belize",
    ISOCode: "BZ",
    timezones: ["America/Belize"],
  },
  {
    text: "+502",
    country: "Guatemala",
    code: "502",
    flag: "🇬🇹",
    countryES: "Guatemala",
    countryPT: "Guatemala",
    ISOCode: "GT",
    timezones: ["America/Guatemala"],
  },
  {
    text: "+503",
    country: "El Salvador",
    code: "503",
    flag: "🇸🇻",
    countryES: "Salvador",
    countryPT: "Salvador",
    ISOCode: "SV",
    timezones: ["America/El_Salvador"],
  },
  {
    text: "+504",
    country: "Honduras",
    code: "504",
    flag: "🇭🇳",
    countryES: "Honduras",
    countryPT: "Honduras",
    ISOCode: "HN",
    timezones: ["America/Tegucigalpa"],
  },
  {
    text: "+505",
    country: "Nicaragua",
    code: "505",
    flag: "🇳🇮",
    countryES: "Nicaragua",
    countryPT: "Nicarágua",
    ISOCode: "NI",
    timezones: ["America/Managua"],
  },
  {
    text: "+506",
    country: "Costa Rica",
    code: "506",
    flag: "🇨🇷",
    countryES: "Costa Rica",
    countryPT: "Costa Rica",
    ISOCode: "CR",
    timezones: ["America/Costa_Rica"],
  },
  {
    text: "+507",
    country: "Panama",
    code: "507",
    flag: "🇵🇦",
    countryES: "Panamá",
    countryPT: "Panamá",
    ISOCode: "PA",
    timezones: ["America/Panama"],
  },
  {
    text: "+508",
    country: "Saint Pierre and Miquelon",
    code: "508",
    flag: "🇵🇲",
    countryES: "San Pedro y Miquelón",
    countryPT: "São Pedro e Miquelon",
    timezones: ["America/Miquelon"],
    ISOCode: "PM",
  },
  {
    text: "+509",
    country: "Haiti",
    code: "509",
    flag: "🇭🇹",
    countryES: "Haití",
    countryPT: "Haiti",
    ISOCode: "HT",
    timezones: ["America/Port-au-Prince"],
  },
  {
    text: "+590",
    country: "Guadeloupe",
    code: "590",
    flag: "🇬🇵",
    countryES: "Guadalupe",
    countryPT: "Guadalupe",
    timezones: ["America/Puerto_Rico", "America/Guadeloupe"],
    ISOCode: "GP",
  },
  {
    text: "+590",
    country: "Saint Barthelemy",
    code: "590",
    flag: "🇧🇱",
    countryES: "San Bartolomé",
    countryPT: "São Bartolomeu",
    timezones: ["America/Puerto_Rico", "America/St_Barthelemy"],
    ISOCode: "BL",
  },
  {
    text: "+590",
    country: "Saint Martin",
    code: "590",
    flag: "🇲🇫",
    countryES: "San Martín",
    countryPT: "São Martinho",
    timezones: ["America/Puerto_Rico", "America/Marigot"],
    ISOCode: "MF",
  },
  {
    text: "+591",
    country: "Bolivia",
    code: "591",
    flag: "🇧🇴",
    countryES: "Bolivia",
    countryPT: "Bolívia",
    ISOCode: "BO",
    timezones: ["America/La_Paz"],
  },
  {
    text: "+592",
    country: "Guyana",
    code: "592",
    flag: "🇬🇾",
    countryES: "Guayana",
    countryPT: "Guiana",
    ISOCode: "GY",
    timezones: ["America/Guyana"],
  },
  {
    text: "+593",
    country: "Ecuador",
    code: "593",
    flag: "🇪🇨",
    countryES: "Ecuador",
    countryPT: "Equador",
    ISOCode: "EC",
    timezones: ["America/Guayaquil", "Pacific/Galapagos"],
  },
  {
    text: "+594",
    country: "French Guiana",
    code: "594",
    flag: "🇬🇫",
    countryES: "Guayana Francesa",
    countryPT: "Guiana Francesa",
    timezones: ["America/Cayenne"],
    ISOCode: "GF",
  },
  {
    text: "+595",
    country: "Paraguay",
    code: "595",
    flag: "🇵🇾",
    countryES: "Paraguay",
    countryPT: "Paraguai",
    ISOCode: "PY",
    timezones: ["America/Asuncion"],
  },
  {
    text: "+596",
    country: "Martinique",
    code: "596",
    flag: "🇲🇶",
    countryES: "Martinica",
    countryPT: "Martinica",
    timezones: ["America/Martinique"],
    ISOCode: "MQ",
  },
  {
    text: "+597",
    country: "Suriname",
    code: "597",
    flag: "🇸🇷",
    countryES: "Surinam",
    countryPT: "Suriname",
    ISOCode: "SR",
    timezones: ["America/Paramaribo"],
  },
  {
    text: "+598",
    country: "Uruguay",
    code: "598",
    flag: "🇺🇾",
    countryES: "Uruguay",
    countryPT: "Uruguai",
    ISOCode: "UY",
    timezones: ["America/Montevideo"],
  },
  {
    text: "+599",
    country: "Curacao",
    code: "599",
    flag: "🇨🇼",
    countryES: "Curazao",
    countryPT: "Curaçao",
    timezones: ["America/Puerto_Rico", "America/Curacao"],
    ISOCode: "CW",
  },
  {
    text: "+670",
    country: "Timor-Leste",
    code: "670",
    flag: "🇹🇱",
    countryES: "Timor Oriental",
    countryPT: "Timor-Leste",
    timezones: ["Asia/Dili"],
    ISOCode: "TL",
  },
  {
    text: "+672",
    country: "Norfolk Island",
    code: "672",
    flag: "🇳🇫",
    countryES: "Isla Norfolk",
    countryPT: "Ilha Norfolk",
    timezones: ["Pacific/Norfolk"],
    ISOCode: "NF",
  },
  {
    text: "+673",
    country: "Brunei Darussalam",
    code: "673",
    flag: "🇧🇳",
    countryES: "Brunéi Darussalam",
    countryPT: "Brunei Darussalam",
    timezones: ["Asia/Kuching", "Asia/Brunei"],
    ISOCode: "BN",
  },
  {
    text: "+674",
    country: "Nauru",
    code: "674",
    flag: "🇳🇷",
    countryES: "Nauru",
    countryPT: "Nauru",
    ISOCode: "NR",
    timezones: ["Pacific/Nauru"],
  },
  {
    text: "+675",
    country: "Papua New Guinea",
    code: "675",
    flag: "🇵🇬",
    countryES: "Papúa Nueva Guinea",
    countryPT: "Papua Nova Guiné",
    ISOCode: "PG",
    timezones: ["Pacific/Port_Moresby", "Pacific/Bougainville"],
  },
  {
    text: "+676",
    country: "Tonga",
    code: "676",
    flag: "🇹🇴",
    countryES: "Tonga",
    countryPT: "Tonga",
    timezones: ["Pacific/Tongatapu"],
    ISOCode: "TO",
  },
  {
    text: "+677",
    country: "Solomon Islands",
    code: "677",
    flag: "🇸🇧",
    countryES: "Islas Salomón",
    countryPT: "Ilhas Salomão",
    ISOCode: "SB",
    timezones: ["Pacific/Guadalcanal"],
  },
  {
    text: "+678",
    country: "Vanuatu",
    code: "678",
    flag: "🇻🇺",
    countryES: "Vanuatu",
    countryPT: "Vanuatu",
    ISOCode: "VU",
    timezones: ["Pacific/Efate"],
  },
  {
    text: "+679",
    country: "Fiji",
    code: "679",
    flag: "🇫🇯",
    countryES: "Fiyi",
    countryPT: "Fiji",
    ISOCode: "FJ",
    timezones: ["Pacific/Fiji"],
  },
  {
    text: "+680",
    country: "Palau",
    code: "680",
    flag: "🇵🇼",
    countryES: "Palaos",
    countryPT: "Palau",
    ISOCode: "PW",
    timezones: ["Pacific/Palau"],
  },
  {
    text: "+681",
    country: "Wallis and Futuna",
    code: "681",
    flag: "🇼🇫",
    countryES: "Wallis y Futuna",
    countryPT: "Wallis e Futuna",
    timezones: ["Pacific/Tarawa", "Pacific/Wallis"],
    ISOCode: "WF",
  },
  {
    text: "+682",
    country: "Cook Islands",
    code: "682",
    flag: "🇨🇰",
    countryES: "Islas Cook",
    countryPT: "Ilhas Cook",
    timezones: ["Pacific/Rarotonga"],
    ISOCode: "CK",
  },
  {
    text: "+683",
    country: "Niue",
    code: "683",
    flag: "🇳🇺",
    countryES: "Niue",
    countryPT: "Niue",
    timezones: ["Pacific/Niue"],
    ISOCode: "NU",
  },
  {
    text: "+685",
    country: "Samoa",
    code: "685",
    flag: "🇼🇸",
    countryES: "Samoa",
    countryPT: "Samoa",
    ISOCode: "WS",
    timezones: ["Pacific/Apia"],
  },
  {
    text: "+686",
    country: "Kiribati",
    code: "686",
    flag: "🇰🇮",
    countryES: "Kiribati",
    countryPT: "Quiribáti",
    ISOCode: "KI",
    timezones: ["Pacific/Tarawa", "Pacific/Kanton", "Pacific/Kiritimati"],
  },
  {
    text: "+687",
    country: "New Caledonia",
    code: "687",
    flag: "🇳🇨",
    countryES: "Nueva Caledonia",
    countryPT: "Nova Caledônia",
    timezones: ["Pacific/Noumea"],
    ISOCode: "NC",
  },
  {
    text: "+688",
    country: "Tuvalu",
    code: "688",
    flag: "🇹🇻",
    countryES: "Tuvalu",
    countryPT: "Tuvalu",
    ISOCode: "TV",
    timezones: ["Pacific/Tarawa", "Pacific/Funafuti"],
  },
  {
    text: "+689",
    country: "French Polynesia",
    code: "689",
    flag: "🇵🇫",
    countryES: "Polinesia Francesa",
    countryPT: "Polinésia Francesa",
    timezones: ["Pacific/Tahiti", "Pacific/Marquesas", "Pacific/Gambier"],
    ISOCode: "PF",
  },
  {
    text: "+690",
    country: "Tokelau",
    code: "690",
    flag: "🇹🇰",
    countryES: "Tokelau",
    countryPT: "Toquelau",
    timezones: ["Pacific/Fakaofo"],
    ISOCode: "TK",
  },
  {
    text: "+691",
    country: "Micronesia",
    code: "691",
    flag: "🇫🇲",
    countryES: "Micronesia",
    countryPT: "Micronésia",
    ISOCode: "FM",
    timezones: ["Pacific/Kosrae", "Pacific/Port_Moresby", "Pacific/Guadalcanal", "Pacific/Chuuk", "Pacific/Pohnpei"],
  },
  {
    text: "+692",
    country: "Marshall Islands",
    code: "692",
    flag: "🇲🇭",
    countryES: "Islas Marshall",
    countryPT: "Ilhas Marshall",
    ISOCode: "MH",
    timezones: ["Pacific/Tarawa", "Pacific/Kwajalein", "Pacific/Majuro"],
  },
  {
    text: "+850",
    country: "Korea Democratic Peoples Republic",
    code: "850",
    flag: "🇰🇵",
    countryES: "República Popular Democrática de Corea",
    countryPT: "República Popular Democrática da Coreia",
    timezones: ["Asia/Pyongyang"],
    ISOCode: "KP",
  },
  {
    text: "+852",
    country: "Hong Kong",
    code: "852",
    flag: "🇭🇰",
    countryES: "Hong Kong",
    countryPT: "Hong Kong",
    ISOCode: "HK",
    timezones: ["Asia/Hong_Kong"],
  },
  {
    text: "+853",
    country: "Macao",
    code: "853",
    flag: "🇲🇴",
    countryES: "Macao",
    countryPT: "Macau",
    timezones: ["Asia/Macau"],
    ISOCode: "MO",
  },
  {
    text: "+855",
    country: "Cambodia",
    code: "855",
    flag: "🇰🇭",
    countryES: "Camboya",
    countryPT: "Camboja",
    ISOCode: "KH",
    timezones: ["Asia/Bangkok", "Asia/Phnom_Penh"],
  },
  {
    text: "+856",
    country: "Lao Peoples Democratic Republic",
    code: "856",
    flag: "🇱🇦",
    countryES: "República Democrática Popular Lao",
    countryPT: "República Democrática Popular do Laos",
    timezones: ["Asia/Bangkok", "Asia/Vientiane"],
    ISOCode: "LA",
  },
  {
    text: "+880",
    country: "Bangladesh",
    code: "880",
    flag: "🇧🇩",
    countryES: "Bangladesh",
    countryPT: "Bangladeche",
    ISOCode: "BD",
    timezones: ["Asia/Dhaka"],
  },
  {
    text: "+886",
    country: "Taiwan",
    code: "886",
    flag: "🇹🇼",
    countryES: "Taiwán",
    countryPT: "Taiwan",
    ISOCode: "TW",
    timezones: ["Asia/Taipei"],
  },
  {
    text: "+960",
    country: "Maldives",
    code: "960",
    flag: "🇲🇻",
    countryES: "Maldivas",
    countryPT: "Maldivas",
    ISOCode: "MV",
    timezones: ["Indian/Maldives"],
  },
  {
    text: "+961",
    country: "Lebanon",
    code: "961",
    flag: "🇱🇧",
    countryES: "Líbano",
    countryPT: "Líbano",
    ISOCode: "LB",
    timezones: ["Asia/Beirut"],
  },
  {
    text: "+962",
    country: "Jordan",
    code: "962",
    flag: "🇯🇴",
    countryES: "Jordania",
    countryPT: "Jordânia",
    ISOCode: "JO",
    timezones: ["Asia/Amman"],
  },
  {
    text: "+963",
    country: "Syrian Arab Republic",
    code: "963",
    flag: "🇸🇾",
    countryES: "República Árabe Siria",
    countryPT: "República Árabe Síria",
    timezones: ["Asia/Damascus"],
    ISOCode: "SY",
  },
  {
    text: "+964",
    country: "Iraq",
    code: "964",
    flag: "🇮🇶",
    countryES: "Irak",
    countryPT: "Iraque",
    ISOCode: "IQ",
    timezones: ["Asia/Baghdad"],
  },
  {
    text: "+965",
    country: "Kuwait",
    code: "965",
    flag: "🇰🇼",
    countryES: "Kuwait",
    countryPT: "Kuwait",
    ISOCode: "KW",
    timezones: ["Asia/Riyadh", "Asia/Kuwait"],
  },
  {
    text: "+966",
    country: "Saudi Arabia",
    code: "966",
    flag: "🇸🇦",
    countryES: "Arabia Saudita",
    countryPT: "Arábia Saudita",
    ISOCode: "SA",
    timezones: ["Asia/Riyadh"],
  },
  {
    text: "+967",
    country: "Yemen",
    code: "967",
    flag: "🇾🇪",
    countryES: "Yemen",
    countryPT: "Lêmen",
    ISOCode: "YE",
    timezones: ["Asia/Riyadh", "Asia/Aden"],
  },
  {
    text: "+968",
    country: "Oman",
    code: "968",
    flag: "🇴🇲",
    countryES: "Omán",
    countryPT: "Omã",
    ISOCode: "OM",
    timezones: ["Asia/Dubai", "Asia/Muscat"],
  },
  {
    text: "+970",
    country: "Palestine",
    code: "970",
    flag: "🇵🇸",
    countryES: "Palestina",
    countryPT: "Palestina",
    timezones: ["Asia/Gaza", "Asia/Hebron"],
    ISOCode: "PS",
  },
  {
    text: "+971",
    country: "United Arab Emirates",
    code: "971",
    flag: "🇦🇪",
    countryES: "Emiratos Árabes Unidos",
    countryPT: "Emirados Árabes Unidos",
    ISOCode: "AE",
    timezones: ["Asia/Dubai"],
  },
  {
    text: "+972",
    country: "Israel",
    code: "972",
    flag: "🇮🇱",
    countryES: "Israel",
    countryPT: "Israel",
    ISOCode: "IL",
    timezones: ["Asia/Jerusalem"],
  },
  {
    text: "+973",
    country: "Bahrain",
    code: "973",
    flag: "🇧🇭",
    countryES: "Bahréin",
    countryPT: "Bahrein",
    ISOCode: "BH",
    timezones: ["Asia/Qatar", "Asia/Bahrain"],
  },
  {
    text: "+974",
    country: "Qatar",
    code: "974",
    flag: "🇶🇦",
    countryES: "Catar",
    countryPT: "Catar",
    ISOCode: "QA",
    timezones: ["Asia/Qatar"],
  },
  {
    text: "+975",
    country: "Bhutan",
    code: "975",
    flag: "🇧🇹",
    countryES: "Bután",
    countryPT: "Butão",
    ISOCode: "BT",
    timezones: ["Asia/Thimphu"],
  },
  {
    text: "+976",
    country: "Mongolia",
    code: "976",
    flag: "🇲🇳",
    countryES: "Mongolia",
    countryPT: "Mongólia",
    ISOCode: "MN",
    timezones: ["Asia/Ulaanbaatar", "Asia/Hovd", "Asia/Choibalsan"],
  },
  {
    text: "+977",
    country: "Nepal",
    code: "977",
    flag: "🇳🇵",
    countryES: "Nepal",
    countryPT: "Nepal",
    ISOCode: "NP",
    timezones: ["Asia/Kathmandu"],
  },
  {
    text: "+992",
    country: "Tajikistan",
    code: "992",
    flag: "🇹🇯",
    countryES: "Tayikistán",
    countryPT: "Tajiquistão",
    ISOCode: "TJ",
    timezones: ["Asia/Dushanbe"],
  },
  {
    text: "+993",
    country: "Turkmenistan",
    code: "993",
    flag: "🇹🇲",
    countryES: "Turkmenistán",
    countryPT: "Turcomenistão",
    ISOCode: "TM",
    timezones: ["Asia/Ashgabat"],
  },
  {
    text: "+994",
    country: "Azerbaijan",
    code: "994",
    flag: "🇦🇿",
    countryES: "Azerbaiyán",
    countryPT: "Azerbaijão",
    ISOCode: "AZ",
    timezones: ["Asia/Baku"],
  },
  {
    text: "+995",
    country: "Georgia",
    code: "995",
    flag: "🇬🇪",
    countryES: "Georgia",
    countryPT: "Geórgia",
    ISOCode: "GE",
    timezones: ["Asia/Tbilisi"],
  },
  {
    text: "+996",
    country: "Kyrgyzstan",
    code: "996",
    flag: "🇰🇬",
    countryES: "Kirguistán",
    countryPT: "Quirguistão",
    ISOCode: "KG",
    timezones: ["Asia/Bishkek"],
  },
  {
    text: "+998",
    country: "Uzbekistan",
    code: "998",
    flag: "🇺🇿",
    countryES: "Uzbekistán",
    countryPT: "Uzbequistão",
    ISOCode: "UZ",
    timezones: ["Asia/Samarkand", "Asia/Tashkent"],
  },
  {
    country: "Antigua and Barbuda",
    code: "1",
    text: "+1",
    flag: "🇦🇬",
    countryES: "Antigua y Barbuda",
    countryPT: "Antígua e Barbuda",
    timezones: ["America/Puerto_Rico", "America/Antigua"],
    ISOCode: "AG",
  },
  {
    country: "Bahamas",
    code: "1",
    text: "+1",
    flag: "🇧🇸",
    countryES: "Bahamas",
    countryPT: "Bahamas",
    timezones: ["America/Toronto", "America/Nassau"],
    ISOCode: "BS",
  },
  {
    country: "Barbados",
    code: "1",
    text: "+1",
    flag: "🇧🇧",
    countryES: "Barbados",
    countryPT: "Barbados",
    timezones: ["America/Barbados"],
    ISOCode: "BB",
  },
  {
    country: "Bermuda",
    code: "1",
    text: "+1",
    flag: "🇧🇲",
    countryES: "Bermudas",
    countryPT: "Bermudas",
    timezones: ["Atlantic/Bermuda"],
    ISOCode: "BM",
  },
  {
    country: "Bonaire Sint Eustatius and Saba",
    code: "599",
    text: "+599",
    flag: "🇧🇶",
    countryES: "Bonaire San Eustaquio y Saba",
    countryPT: "Bonaire Santo Eustáquio e Saba",
    timezones: ["America/Puerto_Rico", "America/Kralendijk"],
    ISOCode: "BQ",
  },
  {
    country: "British Indian Ocean Territory",
    code: "246",
    text: "+246",
    flag: "🇮🇴",
    countryES: "Territorio Británico del Océano Índico",
    countryPT: "Território Britânico do Oceano Índico",
    timezones: ["Indian/Chagos"],
    ISOCode: "IO",
  },
  {
    country: "Chad",
    code: "235",
    text: "+235",
    flag: "🇹🇩",
    countryES: "Chad",
    countryPT: "Chade",
    timezones: ["Africa/Ndjamena"],
    ISOCode: "TD",
  },
  {
    country: "Christmas Island",
    code: "61",
    text: "+61",
    flag: "🇨🇽",
    countryES: "Isla de Navidad",
    countryPT: "Ilha Natal",
    timezones: ["Asia/Bangkok", "Indian/Christmas"],
    ISOCode: "CX",
  },
  {
    country: "Dominica",
    code: "1",
    text: "+1",
    flag: "🇩🇲",
    countryES: "Dominica",
    countryPT: "Domínica",
    timezones: ["America/Puerto_Rico", "America/Dominica"],
    ISOCode: "DM",
  },
  {
    country: "Dominican Republic",
    code: "1809",
    text: "+1809",
    flag: "🇩🇴",
    countryES: "República Dominicana",
    countryPT: "República Dominicana",
    timezones: ["America/Santo_Domingo"],
    ISOCode: "DO",
  },
  {
    country: "Grenada",
    code: "1",
    text: "+1",
    flag: "🇬🇩",
    countryES: "Granada",
    countryPT: "Granada",
    timezones: ["America/Puerto_Rico", "America/Grenada"],
    ISOCode: "GD",
  },
  {
    country: "Guernsey",
    code: "44",
    text: "+44",
    flag: "🇬🇬",
    countryES: "Guernesey",
    countryPT: "Guernsey",
    timezones: ["Europe/London", "Europe/Guernsey"],
    ISOCode: "GG",
  },
  {
    country: "Jamaica",
    code: "1",
    text: "+1",
    flag: "🇯🇲",
    countryES: "Jamaica",
    countryPT: "Jamaica",
    timezones: ["America/Jamaica"],
    ISOCode: "JM",
  },
  {
    country: "Jersey",
    code: "44",
    text: "+44",
    flag: "🇯🇪",
    countryES: "Jersey",
    countryPT: "Jersey",
    timezones: ["Europe/London", "Europe/Jersey"],
    ISOCode: "JE",
  },
  {
    country: "Mayotte",
    code: "262",
    text: "+262",
    flag: "🇾🇹",
    countryES: "Mayotte",
    countryPT: "Maiote",
    timezones: ["Africa/Nairobi", "Indian/Mayotte"],
    ISOCode: "YT",
  },
  {
    country: "Puerto Rico",
    code: "1",
    text: "+1",
    flag: "🇵🇷",
    countryES: "Puerto Rico",
    countryPT: "Porto Rico",
    timezones: ["America/Puerto_Rico"],
    ISOCode: "PR",
  },
  {
    country: "Saint Kitts and Nevis",
    code: "1",
    text: "+1",
    flag: "🇰🇳",
    countryES: "San Cristóbal y Nieves",
    countryPT: "São Cristóvão e Nevis",
    timezones: ["America/Puerto_Rico", "America/St_Kitts"],
    ISOCode: "KN",
  },
  {
    country: "Saint Lucia",
    code: "1",
    text: "+1",
    flag: "🇱🇨",
    countryES: "Santa Lucía",
    countryPT: "Santa Lúcia",
    timezones: ["America/Puerto_Rico", "America/St_Lucia"],
    ISOCode: "LC",
  },
  {
    country: "Saint Vincent and the Grenadines",
    code: "1",
    text: "+1",
    flag: "🇻🇨",
    countryES: "San Vicente y las Granadinas",
    countryPT: "São Vicente e Granadinas",
    timezones: ["America/Puerto_Rico", "America/St_Vincent"],
    ISOCode: "VC",
  },
  {
    country: "Sint Maarten",
    code: "1",
    text: "+1",
    flag: "🇸🇽",
    countryES: "San Martín",
    countryPT: "São Martinho",
    timezones: ["America/Puerto_Rico", "America/Lower_Princes"],
    ISOCode: "SX",
  },
  {
    country: "Trinidad and Tobago",
    code: "1",
    text: "+1",
    flag: "🇹🇹",
    countryES: "Trinidad y Tobago",
    countryPT: "Trinidad e Tobago",
    timezones: ["America/Puerto_Rico", "America/Port_of_Spain"],
    ISOCode: "TT",
  },
  {
    country: "Turks and Caicos Islands",
    code: "1",
    text: "+1",
    flag: "🇹🇨",
    countryES: "Islas Turcas y Caicos",
    countryPT: "Ilhas Turks e Caicos",
    timezones: ["America/Grand_Turk"],
    ISOCode: "TC",
  },
  {
    country: "Virgin Islands US",
    code: "1",
    text: "+1",
    flag: "🇻🇮",
    countryES: "Islas Vírgenes de EE. UU.",
    countryPT: "Ilhas Virgens EUA",
    timezones: ["America/Puerto_Rico", "America/St_Thomas"],
    ISOCode: "VI",
  },
];

export type CountryCodes = string;
